// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2D69j","author":"Table_author__zb5Nd","authorImage":"Table_authorImage__3VVJP","unreadRow":"Table_unreadRow__3q1W3"};